import type { FinalAnswer, StudentAnswerPayload } from "./contracts.js";

export function finalAnswerText(answer: StudentAnswerPayload | FinalAnswer): string {
  const finalAnswer = "finalAnswer" in answer ? answer.finalAnswer : answer;
  switch (finalAnswer.kind) {
    case "exact":
      return finalAnswer.value;
    case "numeric":
      return String(finalAnswer.value);
    case "expression":
      return finalAnswer.latex;
    case "set":
      return `{${finalAnswer.members.join(",")}}`;
    case "structured":
      return finalAnswer.claims.join("；");
  }
}

export function finalAnswerUsesMathTypesetting(answer: StudentAnswerPayload): boolean {
  return (
    answer.finalAnswer.kind === "numeric" ||
    answer.finalAnswer.kind === "expression" ||
    answer.finalAnswer.kind === "set"
  );
}
